import { useFrame } from '@react-three/fiber';

const cameraTarget = [0, 0, 0];

export function useSpin(orbitRef: any) {
  useFrame(() => {
    if (orbitRef.current) {
      const speed = 0.01; // Adjust rotation speed
      const radius = 20; // Distance from the target

      // Update camera position in a circular motion
      const time = performance.now() * 0.05;
      orbitRef.current.object.position.x = Math.sin(time * speed) * radius;
      orbitRef.current.object.position.z = Math.cos(time * speed) * radius;
      orbitRef.current.object.position.y = 7;

      orbitRef.current.object.lookAt(cameraTarget[0], cameraTarget[1], cameraTarget[2]);
      orbitRef.current.update();
    }
  });
}
